/*
 * bs-add-to-cart.js
 * Single, idempotent add-to-cart handler for custom ".bs-btn" product-card buttons.
 *
 * Replaces the inline <script> that was printed once per rendered product card
 * (collection grid, "new_collections" section, cart-drawer upsells) and the
 * re-binding block in theme.js (collection:reloaded). Each copy attached another
 * click listener to every .bs-btn, so one click fired N parallel /cart/add.js
 * requests and the cart ended up with 1..N units depending on how many of those
 * concurrent requests Shopify applied.
 *
 * Load ONCE from layout/theme.liquid:
 *   <script src="{{ 'bs-add-to-cart.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
 
  // Guard: never bind twice, even if this file is included more than once.
  if (window.__bsAddToCartBound) return;
  window.__bsAddToCartBound = true;
 
  // Buttons with a request in flight (blocks accidental double-clicks only;
  // a second deliberate click after the first finishes still adds again).
  var inFlight = new WeakSet();
 
  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  }
 
  // Same behaviour as the previous inline success() function.
  function onAdded(variantId, button) {
    var errors = document.querySelector('.errors');
    if (errors) errors.remove();
 
    if (window.theme && theme.settings && theme.settings.cartType === 'page') {
      window.location = theme.routes.cartPage;
      return;
    }
 
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: variantId, addToCartBtn: button },
      bubbles: true
    }));
  }
 
  // One delegated listener covers cards present at load AND cards injected later
  // (AJAX collection filtering, cart drawer re-render, infinite scroll).
  //
  // Registered on WINDOW in the CAPTURE phase, so it runs before any listener
  // attached directly to a .bs-btn (old inline snippet copies, theme.js
  // collection re-bind). stopImmediatePropagation() then stops those legacy
  // listeners, so only ONE /cart/add.js request is ever sent, even if some old
  // inline <script> copies are still left in the theme.
  window.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('.bs-btn');
    if (!button) return;
 
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
 
    if (inFlight.has(button) || button.disabled) return;
 
    var variantId = button.getAttribute('product-id');
    if (!variantId) {
      console.error('product-id attribute not found on bs-btn element');
      return;
    }
 
    // Optional: allow a card to request more than 1 via data-quantity="2".
    var quantity = parseInt(button.getAttribute('data-quantity'), 10);
    if (!quantity || quantity < 1) quantity = 1;
 
    inFlight.add(button);
    button.classList.add('btn-loading');
    button.setAttribute('aria-busy', 'true');
 
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        onAdded(variantId, button);
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);
      })
      .finally(function () {
        inFlight.delete(button);
        button.classList.remove('btn-loading');
        button.removeAttribute('aria-busy');
      });
  }, true); // capture phase
})();